/* eslint-disable react/jsx-no-target-blank */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from './dialog';
import { push } from 'connected-react-router';
import get from 'lodash/get';
import { getNeedCaseFileDownloadInfo } from 'utils/projectFiles';
import GetAppIcon from '@material-ui/icons/GetApp';
import { EUROPE } from 'enums/regions';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { toast } from 'react-toastify';
import toastConfig from 'enums/toast';
import axios from 'axios';

const API_URL = window.env.API_URL;
const ACCESS_TOKEN = window.env.ACCESS_TOKEN;

const useStyles = makeStyles((theme) => ({
  icon: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
}));

const Actions = ({ push, value, row }) => {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const isClient = get(row, 'data.status', '') === 'Cliente';
  const isClosed = row?.isClosed;
  const isApproved = row?.isApproved;
  const isGanadaStatus = row?.data?.status === 'Ganada';

  const needCase = get(row, 'data.needCase') === true;
  const needCaseFile = getNeedCaseFileDownloadInfo(row?.data ?? {});

  // TODO: issue dd5b5f54-99ee-4b5d-8965-7e22733c2d12, this can unified in a hook or utils function
  const handleDownloadNeedCaseFile = async () => {
    if (!needCaseFile?.uuid) return;
    try {
      const downloadUrl = `${API_URL}/bulk/download-stream/${encodeURIComponent(
        needCaseFile.uuid,
      )}`;
      const response = await axios.get(downloadUrl, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem(ACCESS_TOKEN)}`,
        },
        responseType: 'blob',
      });
      const fallbackName =
        needCaseFile.name ||
        (needCaseFile.key &&
          needCaseFile.key.split('/').filter(Boolean).pop()) ||
        'certificado';
      const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = fallbackName;
      a.click();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Error al descargar el archivo:', error);
      toast.error(
        <FormattedMessage id="Hubo un error al descargar el archivo" />,
        toastConfig,
      );
    }
  };

  const isEuropeCountry = EUROPE.includes(get(row, 'data.country'));
  const isDinoc = row.subtype === 'Dinoc' || row.subtype === 'DinocSmall';
  const isFasara = row.subtype === 'Fasara' || row.subtype === 'FasaraSmall';

  const showDownloadNeedCase =
    isEuropeCountry && needCase && needCaseFile?.uuid;

  // const isAllowedToSendWarrantyCertificate = isClosed && isApproved && isGanadaStatus;
  const isAllowedToSendWarrantyCertificate = isGanadaStatus && !!row.code;

  return (
    <>
      <Button
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        &bull;&bull;&bull;
      </Button>

      {isClosed && isDinoc ? (
        <>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem
              onClick={() => push(`/installer/arqFinishes/dinoc/view/${value}`)}
            >
              <VisibilityIcon className={classes.icon} />
              <FormattedMessage id="Ver" />
            </MenuItem>
            {isAllowedToSendWarrantyCertificate && (
              <MenuItem onClick={handleOpenDialog}>
                <MailOutlineIcon className={classes.icon} />
                <FormattedMessage id="Volver a enviar cert de garantía" />
              </MenuItem>
            )}
            {openDialog && (
              <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                code={value}
              />
            )}
            {showDownloadNeedCase && (
              <MenuItem onClick={handleDownloadNeedCaseFile}>
                <GetAppIcon className={classes.icon} />
                <FormattedMessage id="Descargar certificado" />
              </MenuItem>
            )}
          </Menu>
        </>
      ) : isClosed && isFasara ? (
        <>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem
              onClick={() =>
                push(`/installer/arqFinishes/fasara/view/${value}`)
              }
            >
              <VisibilityIcon className={classes.icon} />
              <FormattedMessage id="Ver" />
            </MenuItem>
            {isAllowedToSendWarrantyCertificate && (
              <MenuItem onClick={handleOpenDialog}>
                <MailOutlineIcon className={classes.icon} />
                <FormattedMessage id="Volver a enviar cert de garantía" />
              </MenuItem>
            )}
            {openDialog && (
              <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                code={value}
              />
            )}
            {showDownloadNeedCase && (
              <MenuItem onClick={handleDownloadNeedCaseFile}>
                <GetAppIcon className={classes.icon} />
                <FormattedMessage id="Descargar certificado" />
              </MenuItem>
            )}
          </Menu>
        </>
      ) : isClient && isDinoc ? (
        <>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem
              onClick={() => push(`/installer/arqFinishes/dinoc/edit/${value}`)}
            >
              <EditIcon className={classes.icon} />
              <FormattedMessage id="Editar" />
            </MenuItem>
            {isAllowedToSendWarrantyCertificate && (
              <MenuItem onClick={handleOpenDialog}>
                <MailOutlineIcon className={classes.icon} />
                <FormattedMessage id="Volver a enviar cert de garantía" />
              </MenuItem>
            )}
          </Menu>
          {openDialog && (
            <Dialog
              open={openDialog}
              onClose={handleCloseDialog}
              code={value}
            />
          )}
        </>
      ) : isClient && isFasara ? (
        <>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem
              onClick={() =>
                push(`/installer/arqFinishes/fasara/edit/${value}`)
              }
            >
              <EditIcon className={classes.icon} />
              <FormattedMessage id="Editar" />
            </MenuItem>
            {isAllowedToSendWarrantyCertificate && (
              <MenuItem onClick={handleOpenDialog}>
                <MailOutlineIcon className={classes.icon} />
                <FormattedMessage id="Volver a enviar cert de garantía" />
              </MenuItem>
            )}
          </Menu>
          {openDialog && (
            <Dialog
              open={openDialog}
              onClose={handleCloseDialog}
              code={value}
            />
          )}
        </>
      ) : isDinoc ? (
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <MenuItem
            onClick={() => push(`/installer/arqFinishes/dinoc/edit/${value}`)}
          >
            <EditIcon className={classes.icon} />
            <FormattedMessage id="Editar" />
          </MenuItem>
          <MenuItem
            onClick={() => push(`/installer/arqFinishes/dinoc/win/${value}`)}
          >
            <AssignmentTurnedInIcon className={classes.icon} />
            <FormattedMessage id="Cambiar proyecto a ganado" />
          </MenuItem>
        </Menu>
      ) : (
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <MenuItem
            onClick={() => push(`/installer/arqFinishes/fasara/edit/${value}`)}
          >
            <EditIcon className={classes.icon} />
            <FormattedMessage id="Editar" />
          </MenuItem>
          <MenuItem
            onClick={() => push(`/installer/arqFinishes/fasara/win/${value}`)}
          >
            <AssignmentTurnedInIcon className={classes.icon} />
            <FormattedMessage id="Cambiar proyecto a ganado" />
          </MenuItem>
        </Menu>
      )}
    </>
  );
};

export default connect(undefined, { push })(Actions);
